import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsDividerSvg } from './WpsDividerSvg'

export const WpsDividerIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsDividerSvg} {...props} />
}
